<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="昵称" prop="nickname">
                <el-input v-model="query.nickname" placeholder="请输入用户昵称" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="苇渡ID" prop="wdId">
                <el-input v-model="query.wdId" placeholder="请输入苇渡ID" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="query.phone" placeholder="请输入手机号" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="注册日期" prop="date">
                <el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </template>
        <template slot="btns">
            <el-button size="mini" type="primary" @click="handleFeedback">
                用户反馈记录
            </el-button>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="昵称" align="center" prop="nickname"></el-table-column>
            <el-table-column label="性别" align="center" prop="gender">
                <template slot-scope="{ row }">
                    {{ row.gender == 1 ? "男" : "女" }}
                </template>
            </el-table-column>
            <el-table-column label="苇渡ID" align="center" prop="wdId"></el-table-column>
            <el-table-column label="手机号" align="center" prop="phone"></el-table-column>
            <el-table-column label="注册时间" align="center" prop="regTime"></el-table-column>
            <el-table-column label="操作" align="center" width="140" v-if="permission('/user/list/detail')">
                <template slot-scope="{ row }">
                    <el-link :underline="false" type="primary" @click="handleDetail(row)">
                        查看详情
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page } from "@/api/user/list";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                nickname: "",
                wdId: "",
                phone: "",
                date: [],
                mjFlag: 0,
                pageNo: 1,
                pageSize: 10
            },
        };
    },
    mixins: [listMixin],
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
                startTime: this.query.date && this.query.date[0] ? this.query.date[0] + " 00:00:00" : "",
                endTime: this.query.date && this.query.date[1] ? this.query.date[1] + " 23:59:59" : ""
            };
            delete params.date;
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records || [];
                    this.total = result.total || 0;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleDetail(row) {
            this.$router.push({ path: "/user/detail", query: { id: row.id } });
        },
        handleFeedback() {
            this.$router.push({ path: "/user/feedback" });
        }
    },
};
</script>